
import AuthPage from "../../components/layout/authPage"

import { OTPForm } from "../../components/otpForm";

export const OTPLogin = () => {
    
    return (
        <AuthPage>
          <OTPForm type="phone" method="login"/>
        </AuthPage>
    )
}